import {
  Grid,
  TextField,
  Button,
  Typography,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Backdrop,
  CircularProgress,
  Stack
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { userAtom } from '../atoms/user';
import { capitalize } from 'lodash';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import Dropzone from '../components/dropzone/Dropzone';
import { useNavigate } from 'react-router';
import Page from '../components/Page';
import { snackbarAtom } from 'src/atoms/snackbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useQuery } from 'react-query';
import { getSpecializations } from 'src/services/specializations.service';
import { getBenefeciaries } from 'src/services/employee.service';
import axios from 'axios';
import { convertImage } from 'src/utils/convertImage';
import * as dayjs from 'dayjs';

const NewRequest = () => {
  const user = useRecoilValue(userAtom);
  const navigate = useNavigate();
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('lg'));

  /* eslint-disable no-unused-vars */
  const [, setSnackbar] = useRecoilState(snackbarAtom);
  const [medicalBills, setMedicalBills] = useState([]);
  const [doctorPrescription, setDoctorPrescription] = useState([]);
  const [reports, setReports] = useState([]);

  const [doctorBill, setDoctorBill] = useState(0);
  const [medicationBill, setMedicationBill] = useState(0);
  const [raysOrAnalysisBill, setRaysOrAnalysisBill] = useState(0);

  const [notes, setNotes] = useState('');
  const [specializationId, setSpecializationId] = useState('');
  const [transactionDate, setTransactionDate] = useState(dayjs(new Date()));

  const [open, setOpen] = useState(false);
  const [reqOwner, setReqOwner] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    setOpen(true);
    const data = {
      notes,
      dr_receipt_bill: doctorBill,
      medications_bill: medicationBill,
      raysOrAnalysisBill: raysOrAnalysisBill,
      transaction_date: transactionDate,
      specialization_id: specializationId
    };
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));

    await Promise.all(
      doctorPrescription
        .map(async (img) => {
          await convertImage({ file: img, formData: formData, key: 'dr_prescription' });
        })
        .concat(
          reports.map(async (img) => {
            await convertImage({ file: img, formData: formData, key: 'analysis_rays_request' });
          })
        )
        .concat(
          medicalBills.map(async (img) => {
            await convertImage({ file: img, formData: formData, key: 'medical_bill' });
          })
        )
    );
    const url =
      user.id === reqOwner
        ? `/employees/${reqOwner}/requests`
        : `/beneficiaries/${reqOwner}/requests`;

    try {
      if (doctorPrescription.length === 0) {
        throw new Error('Doctor Prescriptions can not be empty!');
      }
      if (medicalBills.length === 0) {
        throw new Error('Bills can not be empty!');
      }
      const { status } = await axios({
        url,
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (status !== 201) {
        throw new Error('Something went wrong');
      }
      navigate('../');
    } catch (err) {
      setSnackbar({ severity: 'error', open: true, message: err.message });
      console.log(err);
    }
    setOpen(false);
  };

  return (
    <Page title="Make Request | Incorta Care">
      <form onSubmit={handleSubmit} style={{ paddingInline: match ? '20px' : '0px' }}>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
          <Grid direction="column" alignItems="center" justifyContent="center">
            <Typography variant="h4">Please Wait...</Typography>
            <div style={{ width: '100%', display: 'grid', placeItems: 'center' }}>
              <CircularProgress color="inherit" />
            </div>
          </Grid>
        </Backdrop>
        <Typography variant="h4" style={{ marginBottom: '20px' }}>
          Make Request
        </Typography>

        <Grid container>
          <Grid item container spacing={3} marginBottom={6} md={12} xs={12}>
            <Grid item md={4} xs={12}>
              <BenefeciariesDropDown
                reqOwner={reqOwner}
                setReqOwner={setReqOwner}
                setSnackbar={setSnackbar}
              />
            </Grid>
            <Grid item container md={4} xs={12}>
              <SpecializationsDropDown
                setSnackbar={setSnackbar}
                setSpecializationId={setSpecializationId}
              />
            </Grid>
            <Grid item container md={4} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  renderInput={(props) => <TextField {...props} style={{ width: '100%' }} />}
                  label="Date"
                  value={transactionDate}
                  onChange={(newValue) => {
                    setTransactionDate(newValue);
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>

          <Grid item container spacing={3} md={12} xs={12} marginBottom={6}>
            <Grid item container md={4} xs={12}>
              <TextField
                type="number"
                id="outlined-basic"
                label="Doctor or Hospital Bill (EGP)"
                variant="outlined"
                required
                value={doctorBill}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setDoctorBill(Number(e.target.value));
                }}
              />
            </Grid>
            <Grid item container md={4} xs={12}>
              <TextField
                type="number"
                id="outlined-basic"
                label="Medicine Bill (EGP)"
                variant="outlined"
                required
                value={medicationBill}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setMedicationBill(Number(e.target.value));
                }}
              />
            </Grid>
            <Grid item container md={4} xs={12}>
              <TextField
                type="number"
                id="outlined-basic"
                label="Rays or Analysis Bill (EGP)"
                variant="outlined"
                required
                value={raysOrAnalysisBill}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setRaysOrAnalysisBill(Number(e.target.value));
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          style={{
            marginBottom: '20px',
            justifyContent: 'flex-end',
            flexDirection: 'row',
            padding: 0
          }}
        >
          <Typography variant="h5">
            Prescription
            <span>*</span>
          </Typography>
          <Dropzone setAddedFiles={setDoctorPrescription} addedFiles={doctorPrescription} />
        </Grid>
        <Grid style={{ marginBottom: '20px' }}>
          <Typography variant="h5">
            Bills <span>*</span>
          </Typography>
          <Dropzone setAddedFiles={setMedicalBills} addedFiles={medicalBills} />
        </Grid>
        <Grid style={{ marginBottom: '20px' }}>
          <Typography variant="h5">Reports</Typography>
          <Dropzone setAddedFiles={setReports} addedFiles={reports} />
        </Grid>

        <Grid
          item
          container
          md={12}
          xs={12}
          style={{ display: 'flex', alignItems: 'stretch' }}
          marginBottom={6}
        >
          <Box sx={{ width: '100%' }}>
            <TextField
              id="standard-textarea"
              label="Notes"
              placeholder="Write any additonal information (Eg. health conditions)"
              multiline
              style={{ width: '100%' }}
              variant="standard"
              value={notes}
              onChange={(e) => {
                setNotes(e.target.value);
              }}
            />
          </Box>
        </Grid>

        <Button type="submit" variant="contained">
          Make Request
        </Button>
      </form>
    </Page>
  );
};

const BenefeciariesDropDown = ({ reqOwner, setReqOwner, setSnackbar }) => {
  const user = useRecoilValue(userAtom);
  const {
    data: beneficiaries,
    isLoading: isBeneficiariesLoading,
    error: isBeneficiariesError
  } = useQuery('beneficiaries', () => getBenefeciaries(user.id));
  useEffect(() => {
    if (isBeneficiariesError) {
      setSnackbar({
        open: true,
        message: 'An error has occurred: ' + isBeneficiariesError.message,
        severity: 'error'
      });
    }
  }, [isBeneficiariesError, beneficiaries]);
  if (isBeneficiariesLoading) {
    return <CircularProgress color="inherit" />;
  }
  if (isBeneficiariesError) {
    return (
      <Stack alignItems={'center'} justifyContent={'center'} height={'100%'}>
        {'An error has occurred: ' + isBeneficiariesError.message}
      </Stack>
    );
  }
  return (
    <FormControl variant="standard" sx={{ minWidth: '100%', minHeight: '100%' }} required>
      <InputLabel id="demo-simple-select-filled-label">Request Owner</InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        value={reqOwner}
        onChange={(e) => setReqOwner(e.target.value)}
      >
        <MenuItem value={user.id}>Self</MenuItem>
        {beneficiaries.map((ben) => {
          return (
            <MenuItem key={ben.id} value={ben.id}>
              {ben.name} ({capitalize(ben.relationship)})
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
const SpecializationsDropDown = ({ setSnackbar, setSpecializationId }) => {
  const {
    data: specializations,
    isLoading: isSpecializationsLoading,
    error: isSpecializationsError
  } = useQuery('specializations', getSpecializations);
  const [specializationDescribtion, setSpecializationDescribtion] = useState('');
  useEffect(() => {
    if (isSpecializationsError) {
      setSnackbar({
        open: true,
        message: 'An error has occurred: ' + isSpecializationsError.message,
        severity: 'error'
      });
    }
  }, [isSpecializationsError]);
  if (isSpecializationsLoading) {
    return <CircularProgress color="inherit" />;
  }
  if (isSpecializationsError) {
    return (
      <Stack alignItems={'center'} justifyContent={'center'} height={'100%'}>
        {'An error has occurred: ' + isSpecializationsError.message}
      </Stack>
    );
  }
  return (
    <FormControl variant="standard" sx={{ minWidth: '100%' }} required>
      <InputLabel id="demo-simple-select-filled-label">Specialization Type</InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        value={specializationDescribtion}
        onChange={(e) => {
          setSpecializationDescribtion(e.target.value);
        }}
      >
        {specializations?.data.map((spec) => {
          return (
            <MenuItem
              key={spec.id}
              value={spec.specialization_description}
              onClick={() => setSpecializationId(spec.id)}
            >
              {spec.specialization_description}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
export default NewRequest;
